import { render } from "./EventCreateV2.vue?vue&type=template&id=623fd494&scoped=true"
import script from "./EventCreateV2.vue?vue&type=script&lang=js"
export * from "./EventCreateV2.vue?vue&type=script&lang=js"

import "./EventCreateV2.vue?vue&type=style&index=0&id=623fd494&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623fd494"]])

export default __exports__